import { useQuery } from '@tanstack/react-query';
import _isEmpty from 'lodash/isEmpty';
import { fetcher } from 'src/api/fetcher';
import { API_RESOURCES, PAGINATION_IGNORE_DEFAULT_LIMIT } from 'src/utils/constants';

export const useCurrentUserRoles = user => {
  return useQuery({
    queryFn: () => fetcher(API_RESOURCES.ROLE),
    enabled: Boolean(user),
    select: ({ resources }) => [
      ...new Set(resources.filter(role => role.username === user?.username).map(role => role.role)),
    ],
  });
};

export const useCurrentUserLocations = user => {
  return useQuery({
    queryFn: () => fetcher(API_RESOURCES.ROLE),
    enabled: Boolean(user),
    select: ({ resources }) => [
      ...new Set(
        resources
          .filter(role => role.username === user?.username && role.location)
          .map(role => role.location)
      ),
    ],
  });
};

export const useUsersByUri = (userUris, key = 'usersByUri') => {
  const normalizedUris = Array.isArray(userUris)
    ? [...new Set(userUris.filter(Boolean))].sort()
    : userUris;
  return useQuery({
    queryKey: ['usersByUri', key, normalizedUris],
    queryFn: () =>
      fetcher(API_RESOURCES.USERS, {
        params: {
          'filter[uri]': Array.isArray(normalizedUris) ? normalizedUris.join(',') : normalizedUris,
          'page[limit]': PAGINATION_IGNORE_DEFAULT_LIMIT,
        },
      }),
    enabled: !_isEmpty(normalizedUris),
    select: data => {
      const resources = data.resources;
      return Object.fromEntries(resources.map(item => [item.uri, item]));
    },
  });
};
